import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'app-downloadreintegros',
  templateUrl: './downloadreintegros.page.html',
  styleUrls: ['./downloadreintegros.page.scss'],
})
export class DownloadreintegrosPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
